import React from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import TableFooterMerchandise from './TableFooterMerchandise'

const styles = StyleSheet.create({
    tableContainer: {
        width: '97%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        backgroundColor: '#e2e2e2',
        display: 'flex',
        flexDirection: 'row',
    },
    headers: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        flexWrap: 'wrap',
        height: 24
    },
    text: {
        display: 'flex',
        fontSize: '8px',
        alignSelf: 'center',
        fontWeight: '300'
    },
    tableRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    cell: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'left',
        alignContent: 'left',
        fontSize: '8px',
        textAlign: 'left',
        paddingTop: '2px',
        paddingLeft: '2px'
    },
    cellNumbers: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        fontSize: '8px',
        textAlign: 'center',
        paddingTop: '2px',
        paddingLeft: '2px'
    },
    itemcode: {
        minWidth: '15%',
        maxWidth: '15%',
    },
    ean: {
        minWidth: '18%',
        maxWidth: '18%',
    },
    qty: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    unit: {
        minWidth: '8%',
        maxWidth: '8%'
    },
    description: {
        minWidth: '30%',
        maxWidth: '30%',
    },
    price: {
        minWidth: '15%',
        maxWidth: '15%',
    },
    dicount: {
        minWidth: '7%',
        maxWidth: '7%'
    },
    igv: {
        minWidth: '5%',
        maxWidth: '5%',
    },
    isc: {
        minWidth: '5%',
        maxWidth: '5%',
    },
    total: {
        minWidth: '15%',
        maxWidth: '15%',
    },
});

const StockTransferLines = ({ items, header, view }) => {
    // let blankRows = Array((items.length + 2) - items.length).fill(0)
    return (
        <View style={styles.tableContainer}>
            <View style={[styles.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                <View style={[styles.col6, styles.textLeft]}>
                    <Text>{`Almacén de entrada: ${header?.ToWhsName ?? ''}`}</Text>
                </View>
            </View>
            <View style={styles.tableContainer}>
                <View style={styles.header} fixed>
                    <View style={[styles.headers, styles.igv]}>
                        <Text style={styles.text}>#</Text>
                    </View>
                    <View style={[styles.headers, styles.itemcode]}>
                        <Text style={styles.text}>CÓDIGO ARTÍCULO</Text>
                    </View>
                    <View style={[styles.headers, styles.description]}>
                        <Text style={styles.text}>DESCRIPCIÓN</Text>
                    </View>
                    <View style={[styles.headers, styles.unit]}>
                        <Text style={styles.text}>UNIDAD MEDIDA</Text>
                    </View>
                    <View style={[styles.headers, styles.total]}>
                        <Text style={styles.text}>PESO</Text>
                    </View>
                    <View style={[styles.headers, styles.price]}>
                        <Text style={styles.text}>CANTIDAD</Text>
                    </View>
                    <View style={[styles.headers, styles.price]}>
                        <Text style={styles.text}>P. TOTAL</Text>
                    </View>
                </View>
                {items.map((item, index) => (
                    <View style={styles.tableRow}>
                        <View style={[styles.cell, styles.igv]}>
                            <Text>{index + 1}</Text>
                        </View>
                        <View style={[styles.cell, styles.itemcode]}>
                            <Text>{item.ItemCode}</Text>
                        </View>
                        <View style={[styles.cell, styles.description]}>
                            <Text>{item.Dscription}</Text>
                        </View>

                        <View style={[styles.cell, styles.unit]}>
                            <Text>{item.InvntryUom}</Text>
                        </View>
                        <View style={[styles.cellNumbers, styles.price]}>
                            <Text>{item?.SWeight1 !== "0.000000" ? Number.parseFloat(item?.SWeight1).toFixed(3) : '-'}</Text>
                        </View>
                        <View style={[styles.cellNumbers, styles.total]}>
                            <Text>{Number(item.Quantity)}</Text>
                        </View>
                        <View style={[styles.cellNumbers, styles.total]}>
                            <Text>{Number(item.LineWeightTotal)}</Text>
                        </View>

                    </View>
                ))}
                <View style={[styles.tableRow]}>
                    <View style={[styles.cell, styles.itemcode, { height: '15%' }]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cell, styles.ean]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cell, styles.qty]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cell, styles.unit]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cell, styles.description]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cellNumbers, styles.price]}>
                        <Text>{''}</Text>
                    </View>
                    <View style={[styles.cellNumbers, styles.total]}>
                    </View>
                </View>
                <TableFooterMerchandise header={header} items={items} view={view} />
            </View>


        </View>


    );
};

export default StockTransferLines